import classNames from 'classnames';

import { trans, useSoyuzExperiment } from '@spotahome/soyuz/client';

import { useMediatorModalHandle } from '../utils/withModalHandle';
import { OPEN_PLUS_VALUE_PROPOSITION_MODAL } from '../utils/constants';

import Modal from '../Modal';
import ModalHeader from '../ModalHeader';
import ModalBody from '../ModalBody';

import Tag from '../Tag';
import PlusIcon from '../icons/PlusIcon';
import { isMobileScreen } from '../utils/breakpoints';

import { DSIcon } from '../../../base';

import styles from './PlusValuePropositionModal.module.scss';

const OriginalLabel = () => (
  <Tag
    className={styles['plus-value-proposition-modal__tag']}
    label="Spotahome PLUS"
    colorSchema="blue"
    size="small"
    keepLabelCase
    renderLeadingIcon={() => (
      <PlusIcon
        size="normal"
        className={styles['plus-value-proposition-modal__tag-icon']}
      />
    )}
  />
);

const VariantLabel = () => (
  <span
    className={styles['plus-value-proposition-modal__header-label-with-icon']}
  >
    <DSIcon name="spoke" size="l" />
    Spotahome Plus
  </span>
);

const PlusValuePropositionModal = () => {
  const { isModalOpen, handleModalClose } = useMediatorModalHandle({
    channel: OPEN_PLUS_VALUE_PROPOSITION_MODAL
  });

  const isListingSimplificationHeaderVariant =
    useSoyuzExperiment('ListingSimplificationHeader').get('behaviour') ===
    'variant';

  const bodyClasses = classNames(styles['plus-value-proposition-modal__body'], {
    [styles[
      'plus-value-proposition-modal__body--simplification-header-variant'
    ]]: isListingSimplificationHeaderVariant
  });

  const modalDesktopSize = isListingSimplificationHeaderVariant
    ? 'normal'
    : 'medium';

  if (!isModalOpen) {
    return null;
  }

  return (
    <Modal
      className={styles['plus-value-proposition-modal']}
      ariaHideApp={false}
      contentLabel="modal"
      isOpen={isModalOpen}
      onRequestClose={handleModalClose}
      size={isMobileScreen() ? 'fullscreen' : modalDesktopSize}
    >
      <ModalHeader
        className={styles['plus-value-proposition-modal__header']}
        dataTest="payment-info-close"
        label={
          isListingSimplificationHeaderVariant ? (
            <VariantLabel />
          ) : (
            <OriginalLabel />
          )
        }
        onRequestClose={handleModalClose}
      />
      <ModalBody className={bodyClasses}>
        {isListingSimplificationHeaderVariant ? (
          <>
            <p>{trans('plus.modal.description')}</p>

            <div>
              <h5
                className={
                  styles['plus-value-proposition-modal__conditions-title']
                }
              >
                {trans('plus.modal.conditions1')}
              </h5>
              <ul
                className={
                  styles['plus-value-proposition-modal__conditions-list']
                }
              >
                <li>{trans('plus.modal.conditions1.item1')}</li>
                <li>{trans('plus.modal.conditions1.item2')}</li>
                <li>{trans('plus.modal.conditions1.item3')}</li>
              </ul>
            </div>
          </>
        ) : (
          <>
            <h2 className={styles['plus-value-proposition-modal__body-title']}>
              <strong>{trans('plus.value.proposition.modal.title')}</strong>
            </h2>
            <ul>
              <li
                dangerouslySetInnerHTML={{
                  __html: trans('plus.value.proposition.modal.point1')
                }}
              />
              <li
                dangerouslySetInnerHTML={{
                  __html: trans('plus.value.proposition.modal.point2')
                }}
              />
            </ul>
          </>
        )}
      </ModalBody>
    </Modal>
  );
};

export default PlusValuePropositionModal;
